import { Module } from 'vuex';
import * as firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/functions';
import 'firebase/auth';
import { getRegionName } from '@/utils/functionsRegion';
import { convertToFullWeekdayNames } from '@/utils/dateTimeFormat';


const office365Module: Module<any, any> = {
  state: {
    office365TokenData: { token: null, expirationDateTime: null, email: null, name: null }
  },

  mutations: {
    setOffice365TokenData(state, payload) {
      state.office365TokenData = payload;
    }
  },
  actions: {
    async getMsAccessToken({ commit }, { username, password, facilityId }) {
      return await firebase.app().functions(getRegionName()).httpsCallable('microsoft365-getMsToken')({
          username: username,
          password: password,
          facilityId: facilityId
        })
        .then(response => {
          if (
            response.data?.data?.access_token?.length > 0 &&
            response.data?.data?.expires_in > 0
          ) {
            const currentTime = new Date().getTime();
            const expiresInMilliseconds = response.data.data.expires_in * 1000;

            commit('setOffice365TokenData', {
              email: username,
              name: response.data.data.displayName,
              token: response.data.data.access_token,
              expirationDateTime: new Date(currentTime + expiresInMilliseconds)
            });
          }
          return response;
        });
    },
    async getMsEventSeries({ dispatch, commit }, { id, facilityId, startDateTime, endDateTime }) {
      return await firebase.app().functions(getRegionName()).httpsCallable("microsoft365-getEventSeries")({
        id,
        facilityId,
        startDateTime,
        endDateTime
      })
    },
    async findMsMeetingTimes({ dispatch, commit }, { roomName, office365ResourceEmail, startDateTime, endDateTime, meetingDurationInMins, facilityId, range }) {
        return await firebase.app().functions(getRegionName()).httpsCallable("microsoft365-findMeetingTimes")({
          roomName,
          office365ResourceEmail,
          startDateTime,
          endDateTime,
          meetingDurationInMins,
          facilityId,
          range
      })
    },
    async findMsMeetingTimesForRecurring({ dispatch, commit }, { roomName, office365ResourceEmail, startDateTime, endDateTime, recurrence, meetingDurationInMins, facilityId }) {

      recurrence.repetitionsDays = convertToFullWeekdayNames(recurrence.repetitionsDays)

      return await firebase.app().functions(getRegionName()).httpsCallable("microsoft365-findMeetingTimesForRecurring")({
          roomName,
          office365ResourceEmail,
          startDateTime,
          endDateTime,
          recurrence,
          meetingDurationInMins,
          facilityId
      })
    },
    async getMsRooms({ dispatch, commit }, { facilityId }) {
      try {
        console.log('getting ms rooms')
        return (await firebase.app().functions(getRegionName()).httpsCallable("microsoft365-getRooms")({
          facilityId
        })).data.data
      } catch (error) {
        console.error('getMsRooms error: ', error)
        return []
      }
    },
    async msCalendarView({ dispatch, commit }, { facilityId, range }) {
      return await firebase.app().functions(getRegionName()).httpsCallable("microsoft365-calendarView")({
        facilityId,
        range
      })
    },
    async createMsEvent({ dispatch, commit }, { subject, roomName, startDateTime, endDateTime, office365ResourceEmail, facilityId, recurrence }) {

      if(recurrence && recurrence.repetitionsDays?.length > 0){
        recurrence.repetitionsDays = convertToFullWeekdayNames(recurrence.repetitionsDays)
      }

      return await firebase.app().functions(getRegionName()).httpsCallable("microsoft365-scheduleEvent")({
        subject,
        roomName,
        startDateTime,
        endDateTime,
        office365ResourceEmail,
        facilityId,
        recurrence
      })
    },
    async updateMsEvent({ dispatch, commit }, { id, subject, roomName, startDateTime, endDateTime, office365ResourceEmail, facilityId, recurrence }) {

      if(recurrence && recurrence.repetitionsDays?.length > 0){
        recurrence.repetitionsDays = convertToFullWeekdayNames(recurrence.repetitionsDays)
      }

      return await firebase.app().functions(getRegionName()).httpsCallable("microsoft365-updateEvent")({
        id,
        subject,
        roomName,
        startDateTime,
        endDateTime,
        office365ResourceEmail,
        facilityId,
        recurrence
      })
    },
    async deleteMsEvents({ dispatch, commit }, { ids }) {
      return await firebase.app().functions(getRegionName()).httpsCallable("microsoft365-deleteEvents")({ ids, facilityId: this.state.authModule.currentFacility})
    },
    async deleteMsRecurringEvents({ dispatch, commit }, { ids }) {
      return await firebase.app().functions(getRegionName()).httpsCallable("microsoft365-deleteRecurringEvents")({ ids, facilityId: this.state.authModule.currentFacility})
    },
    async isRoomInMsCalender({ dispatch, commit }, { roomName }) {
      return await firebase.app().functions(getRegionName()).httpsCallable("microsoft365-isRoomInCalender")({ roomName })
    },
    async setoffice365EventIdForRecurringEvents({ dispatch, commit }, { office365EventId, parentEventId }) {
      const eventsSnap = await firebase
      .firestore()
      .collection("calender")
      .where("parentEventId", "==", parentEventId)
      .where("facilityId", "==", this.state.authModule.currentFacility).get()

      for (const doc of eventsSnap.docs) {
        await firebase.firestore().collection("calender").doc(doc.id).update({ office365EventId: office365EventId })
      }
    }
  }
};
export default office365Module;
